module.exports = __webpack_public_path__ + "static/media/take-photo-icon.269aa0d0.svg";